import request from '../utils/csrf-superagent';
import config from '../config';
import businessModelActions from '../actions/businessModel';
import appActions from '../actions/actions';

function submitBusinessModel(store, action) {
    const { businessModelChoice } = action.payload;
    
    const state = store.getState();
    const userInfoMetadata = state.userInfoDetails?.userInfoMetadata || {};
    const softwareDetails = state.softwareDetails || {};

    if (!userInfoMetadata.ipm && !softwareDetails.systemId && !softwareDetails.softwareId && !softwareDetails.onboardAdvertiserDetails) {
        store.dispatch(appActions.enableLoadOverLay(false));
        store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
        return;
    }
    
    const systemId = softwareDetails.systemId || 
                    softwareDetails.onboardAdvertiserDetails?.systemId || 
                    userInfoMetadata.ipm?.resellerName || 
                    userInfoMetadata.ipm?.externalSystemId;
                    
    const advertiserId = softwareDetails.softwareId || 
                        softwareDetails.onboardAdvertiserDetails?.externalId || 
                        userInfoMetadata.ipm?.externalId;

    if (!systemId || !advertiserId) {
        store.dispatch(appActions.enableLoadOverLay(false));
        store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
        return;
    }
    
    const payload = {
        businessModel: businessModelChoice,
        systemId,
        advertiserId
    };
    
    request.post(`/${config.url_prefix}/api/advertiser/businessModel`)
        .send(payload)
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                store.dispatch(appActions.enableLoadOverLay(false));
                store.dispatch(businessModelActions.alertError('internal.server.error'));
            } else if (response.statusCode === 200 || response.statusCode === 201) {
                store.dispatch(businessModelActions.submitBusinessModelSuccess());
                store.dispatch(appActions.changeAppState('SUMMARY'));
            } else {
                store.dispatch(appActions.enableLoadOverLay(false));
                store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
            }
        });
}

export default submitBusinessModel;
